export interface CountryValidationRules {
  requiredFields: string[];
  optionalFields: string[];
}

export const CountryValidationRules: { [key: string]: CountryValidationRules } =
  {
    '230': { requiredFields: ['swift', 'iban'], optionalFields: ['blz'] }, // Alemanha
    '639': {
      requiredFields: ['swift', 'cbu', 'number'],
      optionalFields: ['cuit'],
    }, // Argentina
    '698': { requiredFields: ['swift', 'number'], optionalFields: ['bsb'] }, // Austrália
    '728': { requiredFields: ['swift', 'iban'], optionalFields: [] }, // Áustria
    '876': { requiredFields: ['swift', 'iban'], optionalFields: [] }, // Bélgica
    '1376': { requiredFields: ['swift', 'number'], optionalFields: [] }, // Cayman, Ilhas
    '1490': {
      requiredFields: [
        'swift',
        'institutionNumber',
        'transit',
        'address',
        'number',
      ],
      optionalFields: [],
    }, // Canadá
    '1504': { requiredFields: ['swift', 'number'], optionalFields: [] }, // Canal, Ilhas do (Jersey e Guernsey)
    '1589': { requiredFields: ['swift', 'number'], optionalFields: [] }, // Chile
    '1600': { requiredFields: ['swift', 'number'], optionalFields: [] }, // China
    '7412': { requiredFields: ['swift', 'number'], optionalFields: [] }, // Singapura
    '1694': { requiredFields: ['swift', 'number'], optionalFields: [] }, // Colômbia
    '1902': { requiredFields: ['swift', 'number'], optionalFields: [] }, // Coréia do Sul
    '2321': { requiredFields: ['swift', 'iban'], optionalFields: [] }, // Dinamarca
    '2445': { requiredFields: ['swift', 'iban'], optionalFields: [] }, // Emirados Árabes Unidos
    '2453': { requiredFields: ['swift', 'iban'], optionalFields: [] }, // Espanha
    '2496': { requiredFields: ['swift', 'number'], optionalFields: ['aba'] }, // Estados Unidos
    '1619': { requiredFields: ['swift', 'number'], optionalFields: [] }, // Taiwan
    '2755': { requiredFields: ['swift', 'iban'], optionalFields: [] }, // França
    '3514': { requiredFields: ['swift', 'number'], optionalFields: [] }, // Hong Kong
    '3611': { requiredFields: ['swift', 'number'], optionalFields: [] }, // Índia
    '3654': { requiredFields: ['swift', 'number'], optionalFields: [] }, // Indonésia
    '3751': { requiredFields: ['swift', 'iban'], optionalFields: [] }, // Irlanda
    '3832': { requiredFields: ['swift', 'iban'], optionalFields: [] }, // Israel
    '3867': { requiredFields: ['swift', 'iban'], optionalFields: [] }, // Itália
    '3999': { requiredFields: ['swift', 'number'], optionalFields: [] }, // Japão
    '4936': {
      requiredFields: ['swift', 'number', 'cable'],
      optionalFields: [],
    }, // México
    '5738': { requiredFields: ['swift', 'iban'], optionalFields: [] }, // Países Baixos
    '5800': { requiredFields: ['swift', 'number'], optionalFields: [] }, // Panamá
    '5860': { requiredFields: ['swift', 'number'], optionalFields: [] }, // Paraguai
    '5894': { requiredFields: ['swift', 'number'], optionalFields: [] }, // Peru
    '6114': { requiredFields: ['swift', 'number'], optionalFields: [] }, // Porto Rico
    '6076': { requiredFields: ['swift', 'iban'], optionalFields: [] }, // Portugal
    '6289': { requiredFields: ['swift', 'iban'], optionalFields: ['sortCode'] }, // Reino Unido
    '6700': { requiredFields: ['swift', 'iban'], optionalFields: [] }, // Romênia
    '7676': { requiredFields: ['swift', 'iban'], optionalFields: [] }, // Suíça
    '7765': { requiredFields: ['swift', 'number'], optionalFields: [] }, // Tailândia
    '8273': { requiredFields: ['swift', 'iban'], optionalFields: [] }, // Turquia
    '8451': { requiredFields: ['swift', 'number'], optionalFields: [] }, // Uruguai
  };
